import { jsx, Fragment } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { Input } from '../../ui/input.js';
import { useDevice } from '../../../contexts/DeviceContext.js';
import { cn } from '../../../lib/utils.js';

const FieldRound = forwardRef(
  ({
    id,
    className,
    placeholder = "",
    readOnly = false,
    disabled = false,
    error = false,
    scale = "default",
    ...props
  }, ref) => {
    const { isDesktop } = useDevice();
    const handleKeyDown = (e) => {
      if (e.key === "Enter") {
        if (props.nextInputRef?.current) {
          e.preventDefault();
          props.nextInputRef.current.focus();
          return;
        }
      }
    };
    return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
      Input,
      {
        ref,
        type: "text",
        id,
        placeholder,
        readOnly,
        disabled,
        className: cn(
          "not-data-[keypad-opening]:focus-visible:shadow-[inset_0_0_0_1px_var(--color-border-interactive-primary-default-01)]",
          "data-[keypad-opening=Y]:shadow-[inset_0_0_0_1px_var(--color-border-interactive-primary-default-01)]",
          `${"border border-basic-04 rounded-lg pl-4 pr-3 pt-[17px] pb-[15px] h-[56px] placeholder:text-basic-04 focus-input"}
                         ${error ? "!border-interactive-danger !shadow-[inset_0_0_0_1px_var(--color-border-interactive-danger)]" : ""}`,
          isDesktop && "h-[66px] pl-5 pr-4",
          scale === "small" && "h-[40px] rounded-[8px] body-md",
          readOnly && "border-state-disabled-03 text-basic-02",
          disabled && "border-state-disabled-03 text-basic-02",
          className
        ),
        onKeyDown: handleKeyDown,
        ...props
      }
    ) });
  }
);

export { FieldRound };
